export default __webpack_public_path__ + "static/media/img-0544-slovakia-premium-face.eb3b5cf3.png";